import {createContext, useContext} from 'react';

export const HighlightsSectionIdContext = createContext(null);
export const useHighlightsSectionId = () => useContext(HighlightsSectionIdContext);
